module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('chart-container', {
    attrs: {
      "slot": "raw-body",
      "chartData": _vm.chartData,
      "chartType": 'ChartReport',
      "heading": 'Kursentwicklung Produkt vs. Basiswert (' + _vm.startDate + ' - ' + _vm.endDate + ')',
      "settings": {
        style: {
          width: 680,
          height: 200
        }
      }
    },
    slot: "raw-body"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('table', {
    staticClass: "table is-narrow table-report-development"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Kaufkurs")]), _vm._v(" "), _c('th', [_vm._v("aktueller Kurs "), _c('br'), _vm._v(" "), (['QTR0', 'QTRP'].includes(_vm.product.product.type)) ? _c('span', [_vm._v("(clean)")]) : _vm._e()]), _vm._v(" "), _c('th', [_vm._v("Kursentwicklung "), _c('br'), _vm._v(" "), (['QTR0', 'QTRP'].includes(_vm.product.product.type)) ? _c('span', [_vm._v("(inkl. Stückzinsen)")]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('th', [_vm._v("Gesamt")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "field underlying"
  }, [_vm._m(2), _vm._v(" "), _c('td', [_c('tablefield-currency', {
    attrs: {
      "config": {
        decoratorOptions: {
          currencyPath: 'added.underlyingQuotedAs'
        }
      },
      "data": _vm._.get(_vm.product, 'tradingFigures.underlyingPrice.useAsk'),
      "product": _vm.product
    }
  })], 1), _vm._v(" "), _c('td', [_c('tablefield-currency', {
    attrs: {
      "config": {
        decoratorOptions: {
          currencyPath: 'added.underlyingQuotedAs'
        }
      },
      "data": _vm._.get(_vm.product, 'product.figures.underlyingPrice.useBid'),
      "product": _vm.product
    }
  })], 1), _vm._v(" "), _c('td', [_c('tablefield-percent', {
    attrs: {
      "data": _vm._.get(_vm.product, 'added.development.quote.underlying')
    }
  })], 1), _vm._v(" "), _c('td', [_c('tablefield-currency', {
    attrs: {
      "data": _vm._.get(_vm.product, 'added.development.payout.underlying.complete'),
      "product": _vm.product
    }
  })], 1), _vm._v(" "), _c('td', [_c('tablefield-percent', {
    attrs: {
      "data": _vm._.get(_vm.product, 'added.development.payout.underlying.quote')
    }
  })], 1), _vm._v(" "), _c('td', [_c('tablefield-percent', {
    attrs: {
      "data": _vm._.get(_vm.product, 'added.development.sum.underlying')
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "field product"
  }, [_vm._m(3), _vm._v(" "), _c('td', [_c('tablefield-currency', {
    attrs: {
      "config": {
        decoratorOptions: {
          currencyPath: 'added.productQuotedAs'
        }
      },
      "data": _vm._.get(_vm.product, 'tradingFigures.productPrice.useAsk'),
      "product": _vm.product
    }
  })], 1), _vm._v(" "), _c('td', [_c('tablefield-currency', {
    attrs: {
      "config": {
        decoratorOptions: {
          currencyPath: 'added.productQuotedAs'
        }
      },
      "data": _vm._.get(_vm.product, 'product.figures.productPrice.useBid'),
      "product": _vm.product
    }
  })], 1), _vm._v(" "), _c('td', [_c('tablefield-percent', {
    attrs: {
      "data": _vm._.get(_vm.product, 'added.development.quote.product')
    }
  })], 1), _vm._v(" "), _c('td', [_c('tablefield-currency', {
    attrs: {
      "data": _vm._.get(_vm.product, 'added.development.payout.product.notional'),
      "product": _vm.product
    }
  })], 1), _vm._v(" "), _c('td', [_c('tablefield-percent', {
    attrs: {
      "data": _vm._.get(_vm.product, 'added.development.payout.product.quote')
    }
  })], 1), _vm._v(" "), _c('td', [_c('tablefield-percent', {
    attrs: {
      "data": _vm._.get(_vm.product, 'added.development.sum.product')
    }
  })], 1)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Ausschüttung "), _c('br'), _vm._v(" (Nennbetrag)\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Ausschüttung "), _c('br'), _vm._v(" (Kaufkurs)\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Basiswert")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Produkt")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0450e3d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/ReportDevelopment.vue
// module id = 650
// module chunks = 0